import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '@mdi/react';
import { mdiAccountCircleOutline, mdiCellphoneText, mdiCardAccountDetailsOutline, mdiDotsHorizontal } from '@mdi/js';
import { Link } from '@tanstack/react-router';

const staticLinkOnclick = () => {
    $('body').toggleClass('is-nav-mobile-active');
};
const BottomNav = () => {
    const { t } = useTranslation();

    useEffect(() => {
        const body = document.body;
        body.classList.add('is-nav-bottom-active');
        return () => body.classList.remove('is-nav-bottom-active');
    }, []);

    return (
        <nav className='nav-bottom'>
            <Link
                to='/$'
                params={{ _splat: '/' }}
                className='nav-link'
            >
                <Icon
                    path={mdiAccountCircleOutline}
                    className='nav-link-icon mdi mdi-36'
                />
                <span className='nav-link-text'>{t('navBottom.membership')}</span>
            </Link>
            <Link
                to='/$'
                params={{ _splat: '/kontakt' }}
                className='nav-link'
            >
                <Icon
                    path={mdiCellphoneText}
                    className='nav-link-icon mdi mdi-36'
                />
                <span className='nav-link-text'>{t('navBottom.contactDetails')}</span>
            </Link>
            <Link
                to='/$'
                params={{ _splat: '/anstallning' }}
                className='nav-link'
            >
                <Icon
                    path={mdiCardAccountDetailsOutline}
                    className='nav-link-icon mdi mdi-36'
                />
                <span className='nav-link-text'>{t('navBottom.occupation')}</span>
            </Link>
            <a
                className='nav-link is-clickable'
                onClick={staticLinkOnclick}
            >
                <Icon
                    path={mdiDotsHorizontal}
                    className='nav-link-icon mdi mdi-36'
                />
                <span className='nav-link-text'>{t('navBottom.more')}</span>
            </a>
        </nav>
    );
};

export default BottomNav;
